import React, { useState, useEffect } from 'react';
import './style.css';

function Carousel({ images,pngImg }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const autoScrollInterval = 2200;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, autoScrollInterval);

    return () => {
      clearInterval(timer);
    };
  }, [images]);

  return (
    <div className="carousel">
      <div className="image-container">
        {images.map((image, index) => (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img
            key={index}
            src={image}
            alt={`Image ${index}`}
            className={index === currentImageIndex ? 'active' : ''}
          />
        ))}
      </div>
    </div>
  );
}

export default Carousel;
